import { render, staticRenderFns } from "./gc-checkbox-header.vue?vue&type=template&id=0bb96f8f&"
import script from "./gc-checkbox-header.vue?vue&type=script&lang=js&"
export * from "./gc-checkbox-header.vue?vue&type=script&lang=js&"
import style0 from "./gc-checkbox-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports